import { HttpClient, HttpClientOptions } from '@wix/http-client';

export const createHttpClient = (baseURL?: string, getInstance?: () => string) => {
  return new HttpClient({ baseURL, getAppToken: getInstance });
};

export const createHttpClientRaw = (params: HttpClientOptions) => {
  return new HttpClient(params);
};
